import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import Header from '../components/Header';
import Hero from '../sections/Hero';
import HowItWorks from '../sections/HowItWorks';
import StayInTouch from '../sections/StayInTouch';
import PartOfFun from '../sections/PartOfFun';
import StayTuned from '../sections/StayTuned';
import Footer from '../components/Footer';

import groundMobile from '../assets/ground.png';

const background = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/BG%20Image%20Hero3.jpg';
const ground = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/ground.png';

const Home = () => {
  const isMobile = useMediaQuery('(max-width:439px)');
  const isTablet = useMediaQuery('(min-width:440px) and (max-width:1024px)');
  const isLargeTablet = useMediaQuery('(min-width:1025px) and (max-width:1499px)');

  return (
    <Box
      sx={{
        maxWidth: '1920px',
        mx: 'auto',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <Box
        sx={{
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundBlendMode: 'normal',
        }}
      >
        <Header />
        <Hero />
      </Box>

      <Box sx={{ backgroundColor: '#000000' }}>
        <HowItWorks />
      </Box>

      <Box sx={{ backgroundColor: '#ECECEC' }}>
        <StayInTouch />
      </Box>

      <Box
        sx={{
          backgroundImage: isMobile
            ? `linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 70%, #000000 100%), url(${groundMobile})`
            : `linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 70%, #000000 100%), url(${ground})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: isMobile
            ? 'center 88%'
            : isTablet
            ? 'center 90%'
            : isLargeTablet
            ? 'center 80%'
            : 'center 70%',
          backgroundBlendMode: 'normal',
        }}
      >
        <PartOfFun />
      </Box>

      <Box sx={{ backgroundColor: '#000000' }}>
        <StayTuned />
      </Box>

      <Box sx={{ backgroundColor: '#000000' }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default Home;
